<script setup>
import { ref, watch, onMounted } from "vue"
import { $bus } from '@/common/events'

onMounted(async () => {
    const bounceLogo = document.getElementById('bounce-logo');
    const containerWidth = document.body.clientWidth; 
    const containerHeight = document.body.clientHeight;
    const logoWidth = bounceLogo.offsetWidth; 
    const logoHeight = bounceLogo.offsetHeight;
    const inactivityTimeout = 0.5 * 60 * 1000; // CHANGE THE FIRST NUMBER HERE TO SET YOUR TIMEOUT IN MINUTES

    let xPos = Math.random() * (containerWidth - logoWidth);
    let yPos = Math.random() * (containerHeight - logoHeight);
    let xSpeed = 2; 
    let ySpeed = 2;
    let inactivityTimer = null;

    function resetInactivityTimer() {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(handleInactivity, inactivityTimeout);
    }

    function handleInactivity() {
    console.log("User has been inactive for 5 minutes!");
    xPos = Math.random() * (containerWidth - logoWidth);
    yPos = Math.random() * (containerHeight - logoHeight);
    }

    let currentHue = 0; // To keep track of the color shift amount

    function animate() {
    xPos += xSpeed;
    yPos += ySpeed;

    // Collision detection (with color change on corner hits)
    let colorShift = false; // Flag to indicate if color shift should happen
    if (xPos + logoWidth >= containerWidth || xPos <= 0) {
    xSpeed = -xSpeed;
    colorShift = true;
    }
    if (yPos + logoHeight >= containerHeight || yPos <= 0) {
    ySpeed = -ySpeed;
    colorShift = true;
    }

    // Apply color shift if needed
    if (colorShift) {
    currentHue += 15; // Increment by 15 degrees
    bounceLogo.style.filter = `hue-rotate(${currentHue}deg)`;
    }

    bounceLogo.style.left = xPos + 'px';
    bounceLogo.style.top = yPos + 'px';

    requestAnimationFrame(animate);
    resetInactivityTimer();

    }

    window.addEventListener('mousemove', resetInactivityTimer);
    window.addEventListener('keydown', resetInactivityTimer);
    window.addEventListener('scroll', resetInactivityTimer);

    resetInactivityTimer(); 
    animate(); 
});
</script>

<template>
  <div id="bounce-logo" class="w-full h-screen"></div>
</template>

<style scoped>
/*
body { 
  margin: 0; 
  height: 100vh; 
  background-color: #192958;
  overflow: hidden; 
}
*/

#bounce-logo {
  position: absolute;
  width: 150px;
  height: 80px;
  background-image: url('/img/screensaver/plt-logo-white.png'); 
  background-size: contain; 
  background-repeat: no-repeat;
  filter: hue-rotate(0deg); /* Initialize with no color shift */
  transition: filter 0.5s ease; /* Add a smooth transition effect */
}
</style>
